import { roundAmount } from '@utils';
import { useCallback } from 'react';

type State = {
  min: number | string;
  max: number | string;
};

const useTransformCurrency = (rateCurrency: number) => {
  const getAmountRangeTranslate = useCallback(
    (value: State) => {
      /** 
        When not have integration use data translated from api response
      */
      if (rateCurrency === 1) return value;

      const min = roundAmount(+value.min * rateCurrency);
      const max = roundAmount(+value.max * rateCurrency);

      return { min, max };
    },
    [rateCurrency]
  );

  const getAmountRangeOrigin = useCallback(
    (amountRangeTranslate: State) => {
      const max = amountRangeTranslate.max ? +amountRangeTranslate.max / rateCurrency : 0;
      const min = amountRangeTranslate.min ? +amountRangeTranslate.min / rateCurrency : 0;

      return { max, min };
    },
    [rateCurrency]
  );

  return { getAmountRangeTranslate, getAmountRangeOrigin };
};

export default useTransformCurrency;
